import React, {Fragment} from "react";
import {ActionType} from "../list/list/DataTable";
import {MonetaryConfigListRequest, TurnoverContributions, TurnoverContributionsListRequest} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {ListView, ListViewProps, ListViewState} from "../ListView";
import {FormListener} from "../form/Form";
import {MonetaryConfigService} from "../../services/MonetaryConfigService";


interface State extends ListViewState<MonetaryConfigListRequest> {
    form? : MonetaryConfigListRequest;
    validationMap? : any;
}
interface Props extends ListViewProps  {

}

export class MonetaryConfigListView extends ListView<State, MonetaryConfigListRequest> implements FormListener<MonetaryConfigListRequest>{

    columns = [
        { property : "id", name : "ID", orderBy : "id"},
        { property : "name", name : "Name"},
        { property: "currencyCode", name : "Currency", orderBy: "currency"},
        { property: "awardType", name : "Award Type" },
        { property: "turnoverRequirementFactor", name : "Turnover Requirement" },
        { property: "awardAmountFraction", name : "Award Amount Fraction"}
    ];

    actions = [
        { id : "delete", name : "delete", className : "btn btn-danger", iconClassName : "fa fa-times", type : ActionType.CONFIRMATION},
        { id : "view", name : "View", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/bonus/monetary-config/" + item.id }

    ];

    service : MonetaryConfigService;

    constructor(props : Props){
        super(props, "/bonus/monetary-configs/list");
        this.state = {...this.state, validationMap : {}, form : {...this.state.listRequest}};
        this.service = getContainer().getMonetaryConfigService();

    }
    onSubmit() : void | Promise<any> {
        if(this.state.form) {
            this.updateListState(this.state.form);
        }
    }
    onSubmitError() :  void {

    }

    formDidUpdate(formModel: TurnoverContributionsListRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item : TurnoverContributions, action : string) : Promise<any> | undefined {
        if(action === "delete") {
            return  this.service.remove(""+item.id);
        }
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            console.log("pager changed!", pager);
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.updateListState(listRequest);
        }
    }
    getTitle() {
        return "Monetary Configs";
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}/>
            </Fragment>
        );
    }



}

export default withRouter(MonetaryConfigListView);
